import AdminLayout from "@/components/AdminLayout";
import FileManager from "@/components/FileManager";

export default function Documents() {
  return (
    <AdminLayout title="DOCUMENTS">
      <FileManager
        section="documents"
        allowedExtensions={[
          ".txt",
          ".pdf",
          ".doc",
          ".docx",
          ".xls",
          ".xlsx",
          ".ppt",
          ".pptx",
          ".csv",
          ".json",
          ".xml",
          ".md",
        ]}
        canCreateText={false}
      />
    </AdminLayout>
  );
}
